import { BreadcrumbDataSearchStateData } from '@occ/api-client';

const getListingPageListName = (
  pageName: string,
  query: string | Array<string>,
  breadcrumbs?: Array<BreadcrumbDataSearchStateData>
) => {
  const listName = `${pageName} | ${Array.isArray(query) ? query.join('/') : query}`;

  if (breadcrumbs?.length) {
    return `${listName} | Filters: ${breadcrumbs.map((bc) => bc.facetValueName).join(',')}`;
  }

  return listName;
};

export default getListingPageListName;
